import { render, staticRenderFns } from "./PostLikeField.vue?vue&type=template&id=7ae54ebc&scoped=true&"
import script from "./PostLikeField.vue?vue&type=script&lang=ts&"
export * from "./PostLikeField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae54ebc",
  null
  
)

export default component.exports